import { DEPLOYMENT_URL } from "../../../api";
import { Permission } from "../../../types/Permissions";
import { authDelete, authGet, authPost, authPut } from "../../auth/auth";
import { Integration } from "./types";

export const fetchIntegrationsIfPermitted = (
  deploymentId: string,
  permissions: Permission[]
) => {
  if (!permissions.includes(Permission.panel_policy)) {
    return Promise.resolve({ integrations: [] });
  }

  return authGet<{ integrations: Integration[] }>(
    `${DEPLOYMENT_URL}/${deploymentId}/integrations`
  );
};

interface IntegrationBody extends Integration {
  token?: string;
}

export const createIntegration = (
  deploymentId: string,
  integration: Integration,
  token: string
) => {
  let integrationBody: IntegrationBody = {
    ...integration,
    token,
  };
  return authPost<IntegrationBody, Integration>(
    `${DEPLOYMENT_URL}/${deploymentId}/integrations`,
    integrationBody
  );
};

export const updateIntegration = (
  deploymentId: string,
  integration: Integration,
  token?: string
) => {
  let integrationBody: IntegrationBody = integration;
  if (token) {
    integrationBody.token = token;
  }
  return authPut<IntegrationBody, Integration>(
    `${DEPLOYMENT_URL}/${deploymentId}/integrations/${integration.id}`,
    integrationBody
  );
};

interface InvocationBody {
  issue_id: number;
}

interface InvocationResponse {
  issue_key: string;
}

export const invokeIntegration = (
  deploymentId: string,
  integration: Integration,
  issueId: number
) => {
  return authPost<InvocationBody, InvocationResponse>(
    `${DEPLOYMENT_URL}/${deploymentId}/integrations/${integration.id}/invocation`,
    { issue_id: issueId }
  );
};

export const deleteIntegration = (
  deploymentId: string,
  integrationId: number
) => {
  return authDelete<Integration>(
    `${DEPLOYMENT_URL}/${deploymentId}/integrations/${integrationId}`
  );
};
